import React from 'react';
import { NavLink } from 'react-router-dom';
import logo from '../assets/images/logo.png';
import { auth } from '../firebase';

export default function AdminLayout({ children }) {
  const handleSignOut = async () => {
    try { await auth.signOut(); } catch (e) {}
  };

  const user = auth.currentUser;

  return (
    <div className="container admin-main">
      <div className="admin-grid">
        <aside className="sidebar">
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
            <img src={logo} alt="Moro" style={{ height: 36, width: 'auto' }} />
            <div style={{ fontWeight: 800, letterSpacing: 0.4 }}>Admin</div>
          </div>
          <nav className="sidebar-nav" style={{ display: 'grid', gap: 6 }}>
            <NavLink to="/users" className={({ isActive }) => isActive ? 'active' : ''}>Users</NavLink>
            <NavLink to="/tasks" className={({ isActive }) => isActive ? 'active' : ''}>Tasks</NavLink>
            <NavLink to="/categories" className={({ isActive }) => isActive ? 'active' : ''}>Categories</NavLink>
          </nav>
          <div style={{ marginTop: 12, fontSize: 12, color: 'var(--text-secondary)' }}>
            {user ? (
              <div>
                Signed in as <strong>{user.email || 'unknown'}</strong>
              </div>
            ) : (
              <div>Not signed in</div>
            )}
          </div>
          <div className="sidebar-footer" style={{ marginTop: 16 }}>
            <button className="btn btn-pill btn-accent" onClick={handleSignOut} style={{ width: '100%' }}>Sign out</button>
          </div>
        </aside>
        <main>
          {children}
        </main>
      </div>
    </div>
  );
}